import React from 'react';
import { reduxForm, Field, change } from 'redux-form';
import { Form, Grid, Icon } from 'semantic-ui-react';
import { DatePickerField } from 'Common/SemanticWrapper';

import { APPLY_CYCLE_MENU_FORM_NAME } from 'Common/FormEnum';
import { ApplyCycleMenuFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import { SelectSitesTableReduxForm } from 'Common/SelectSitesTableReduxForm';
import { InputMode } from 'Common/FormEnum';
import { CheckboxField, InputField } from 'Common/SemanticWrapper';
import { Base64Image } from 'Common/Components';
import * as PublishImages from 'Common/Resources/Images/ApplyCycleMenu';
import { IMAGE_FILE_TYPES } from 'Common/Constants';
import { rangeDateValidator } from 'Common/FormHelper';

const ApplyCycleMenuFormContainer = ({ formValues = {}, change }) => (
  <Form name={APPLY_CYCLE_MENU_FORM_NAME}>
    <TitledCard title="Date Range" tight>
      <Grid padded={false}>
        <Grid.Row>
          <Grid.Column width={4}>
            <Field
              name={Fields.StartDateTime}
              label="From"
              component={DatePickerField}
              placeholder="Select a date"
              hideEmptyError
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Field
              name={Fields.EndDateTime}
              label="To"
              component={DatePickerField}
              placeholder="Select a date"
              hideEmptyError
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Field
              name={Fields.StartDay}
              label="Begin with Cycle Day"
              component={InputField}
              mode={InputMode.Integer}
              hideEmptyError
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </TitledCard>
    <TitledCard title="Publish To" tight>
      <Grid padded={false}>
        <Grid.Row columns="equal">
          <Grid.Column textAlign="center">
            <Field name={Fields.PublishToWebsite} component={CheckboxField} />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.Websites}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(
                  Fields.PublishToWebsite,
                  !formValues[Fields.PublishToWebsite]
                );
              }}
            />
            <div className="publish-location-text">Website</div>
            {formValues[Fields.PublishToWebsite] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field name={Fields.PublishToOMD} component={CheckboxField} />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.OnlineMenuDesigner}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(Fields.PublishToOMD, !formValues[Fields.PublishToOMD]);
              }}
            />
            <div className="publish-location-text">Online Menu Designer</div>
            {formValues[Fields.PublishToOMD] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field
              name={Fields.PublishToMobileMenus}
              component={CheckboxField}
            />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.Mobile}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(
                  Fields.PublishToMobileMenus,
                  !formValues[Fields.PublishToMobileMenus]
                );
              }}
            />
            <div className="publish-location-text">Mobile Menus</div>
            {formValues[Fields.PublishToMobileMenus] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field
              name={Fields.PublishToDigitalDisplays}
              component={CheckboxField}
            />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.Digitals}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(
                  Fields.PublishToDigitalDisplays,
                  !formValues[Fields.PublishToDigitalDisplays]
                );
              }}
            />
            <div className="publish-location-text">Digital Displays</div>
            {formValues[Fields.PublishToDigitalDisplays] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field
              name={Fields.PublishToOnlineOrdering}
              component={CheckboxField}
            />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.OnlineOrdering}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(
                  Fields.PublishToOnlineOrdering,
                  !formValues[Fields.PublishToOnlineOrdering]
                );
              }}
            />
            <div className="publish-location-text">Online Ordering</div>
            {formValues[Fields.PublishToOnlineOrdering] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field
              name={Fields.PublishToGoingGreen}
              component={CheckboxField}
            />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.Emails}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(
                  Fields.PublishToGoingGreen,
                  !formValues[Fields.PublishToGoingGreen]
                );
              }}
            />
            <div className="publish-location-text">Automated Email Menus</div>

            {formValues[Fields.PublishToGoingGreen] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field name={Fields.PublishToPOS} component={CheckboxField} />
            <Base64Image
              className="pointer-cursor"
              src={PublishImages.POS}
              type={IMAGE_FILE_TYPES.PNG}
              onClick={() => {
                change(Fields.PublishToPOS, !formValues[Fields.PublishToPOS]);
              }}
            />
            <div className="publish-location-text">Point of Sale</div>
            {formValues[Fields.PublishToPOS] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Field
              name={Fields.PublishToK12PaymentCenter}
              component={CheckboxField}
              disabled
            />
            <Base64Image
              // className="pointer-cursor"
              src={PublishImages.K12}
              onClick={() => {
                // change(
                //   Fields.PublishToK12PaymentCenter,
                //   !formValues[Fields.PublishToK12PaymentCenter]
                // );
              }}
            />
            <div className="publish-location-text">Parent Payment Portal</div>
            {formValues[Fields.PublishToK12PaymentCenter] && (
              <Icon
                className="manage-menu-publish-icon"
                name="checkmark"
                color="green"
                size="massive"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </TitledCard>
    <TitledCard title="Sites" tight>
      <Field
        name={Fields.SiteIds}
        component={SelectSitesTableReduxForm}
        fetchAllSites={true}
      />
    </TitledCard>
  </Form>
);

const validate = (values) => {
  const errors = {};

  if (!values[Fields.StartDay]) {
    errors[Fields.StartDay] = 'Begin with Cycle Day Required';
  } else {
    if (Number(values[Fields.StartDay]) <= 0) {
      errors[Fields.StartDay] =
        'Begin with Cycle Day must be greater than zero.';
    }
    if (Number(values[Fields.StartDay]) > values[Fields.NumberOfDaysInCycle]) {
      errors[Fields.StartDay] =
        'Begin with Cycle Day cannot exceed ' +
        values[Fields.NumberOfDaysInCycle] +
        '.';
    }
  }

  const dateErrors = rangeDateValidator(
    values[Fields.StartDateTime],
    values[Fields.EndDateTime],
    {
      granularity: 'day',
      fromName: Fields.StartDateTime,
      toName: Fields.EndDateTime,
      fromLabel: 'From',
      toLabel: 'To',
    }
  );

  if (
    !Array.isArray(values[Fields.SiteIds]) ||
    values[Fields.SiteIds].length < 1
  ) {
    errors[Fields.SiteIds] = 'Please select a site or site group';
  }

  return {
    ...dateErrors,
    ...errors,
  };
};

const onChange = (values, dispatch, props) => {
  const publishMenu = Boolean(
    values[Fields.PublishToPOS] ||
      values[Fields.PublishToDigitalDisplays] ||
      values[Fields.PublishToGoingGreen] ||
      values[Fields.PublishToK12PaymentCenter] ||
      values[Fields.PublishToOMD] ||
      values[Fields.PublishToOnlineOrdering] ||
      values[Fields.PublishToWebsite] ||
      values[Fields.PublishToMobileMenus]
  );

  if (values[Fields.PublishMenu] !== publishMenu) {
    dispatch(
      change(APPLY_CYCLE_MENU_FORM_NAME, Fields.PublishMenu, publishMenu)
    );
  }
};

const ApplyCycleMenuForm = reduxForm({
  form: APPLY_CYCLE_MENU_FORM_NAME,
  validate,
  onChange,
})(ApplyCycleMenuFormContainer);

export { ApplyCycleMenuForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/ApplyCycleMenuForm.js